import BaseApi from './BaseApi';

export type Kaiin = {
  kaiinName: string;
  companyId: string;
  kaiinLogo: string;
  hasAccount?: boolean;
};

/**
 * 会員検索API。
 */
class SearchKaiinApi extends BaseApi {
  async get(id: string) {
    return await this.execute('athomeSearchKaiinApi', {
      method: 'POST',
      body: { searchCompanyId: id }
    }).then(({ result }) => result.kaiin as Kaiin);
  }
}

export default SearchKaiinApi;
